import theme from '../../styles/Themecolors';
import salesIcon from '../../assets/images/dashboardimages/Icon/salesIcon.svg';
import purchaseIcon from '../../assets/images/dashboardimages/Icon/purchaseIcon.svg';
import Bank from '../../assets/images/dashboardimages/Icon/Bank.svg';
import Cash from '../../assets/images/dashboardimages/Icon/Cash.svg';
import Netprofit from '../../assets/images/dashboardimages/Icon/Netprofit.svg';
import TopeExpenses from '../../assets/images/dashboardimages/Icon/TopExpenses.svg';

export const businessOverviewCardData = [
  {
    type: 'Hz',
    label: 'Sales',
    key: 'Sales',
    amount: 0,
    timePeriod: 'This financial Year',
    period: 'This financial Year',
    icon: salesIcon,
    typeCd: 'PandL',
  },
  {
    type: 'Hz',
    label: 'Purchases',
    key: 'Trading Expense',
    amount: 0,
    timePeriod: 'This financial Year',
    period: 'This financial Year',
    icon: purchaseIcon,
    typeCd: 'PandL',
  },
  {
    type: 'Hz',
    label: 'Cash in Bank',
    key: 'Bank Accounts',
    amount: 0,
    timePeriod: 'Today',
    icon: Bank,
    period: 'This financial Year',
    typeCd: 'BS',
  },
  {
    type: 'Hz',
    label: 'Cash in Hand',
    key: 'Cash in Hand',
    amount: 0,
    timePeriod: 'Today',
    icon: Cash,
    period: 'This financial Year',
    typeCd: 'BS',
  },
  {
    type: 'Hz',
    label: 'Net profit',
    key: 'Net profit',
    amount: 0,
    icon: Netprofit,
    timePeriod: 'This financial year',
    period: 'This financial Year',
    typeCd: 'BS',
  },
  {
    type: 'Hz',
    label: 'Top 5 Expenses',
    key: 'Exp',
    amount: 0,
    timePeriod: 'This financial year',
    icon: TopeExpenses,
    period: 'This financial Year',
    typeCd: 'BS',
  },
  {
    type: 'Vl',
    label: 'Today',
    key: 'T',
    color: theme.palette.background.tablebg,
    amount: 0,
    period: 'Today',
    flag: 1,
  },
  {
    type: 'Vl',
    label: 'This Week',
    key: 'TW',
    color: theme.palette.background.tablebg1,
    period: 'This Week',
    amount: 0,
    flag: 2,
  },
  {
    type: 'Vl',
    label: 'This Month',
    color: theme.palette.tertiary.main,
    key: 'TM',
    period: 'This Month',
    amount: 0,
    flag: 2,
  },
  {
    type: 'Vl',
    label: 'This Quarter',
    key: 'TQ',
    color: theme.palette.sideBar.main,
    amount: 0,
    period: 'This Quarter',
    flag: 2,
  },
  {
    type: 'Vl',
    label: 'Cash Outflow',
    key: 'Co',
    color: theme.palette.background.tablebg1,
    amount: 0,
    flag: 3,
  },
  {
    type: 'Vl',
    label: 'Cash Inflow',
    key: 'Ci',
    color: theme.palette.tertiary.main,
    amount: 0,
    flag: 3,
  },
  {
    type: 'Vl',
    label: 'Opening Cash in Hand',
    key: 'Op',
    color: theme.palette.sideBar.main,
    amount: 0,
    flag: 3,
  },
];

export const BusinessOverviewperiods = [
  {
    label: 'This Financial Year',
    key: 1,
    value: '',
  },
  {
    label: 'This Month',
    key: 2,
    value: '',
  },
  {
    label: 'This Quarter',
    key: 3,
    value: '',
  },
];

export const periodOptions = [
  { value: 'fy', label: 'This FY' },
  { value: 'month', label: 'This Month' },
  { value: 'quarter', label: 'This Quarter' },
];

export const defaultSettings = {
  title: '',
  id: 0,
  serialisactive: true,
  prefix: '',
  nextinvoicenumber: null,
  suffix: '',
  preview: '',
  taxability: '',
};

export const billingCurrencyOptions = [
  { label: 'Rupee (₹)', value: '1', sign: '₹', code: 'INR' },
  { label: 'US Dollar ($)', value: '2', sign: '$', code: 'USD' },
  { label: 'Euro (€)', value: '3', sign: '€', code: 'EUR' },
  { label: 'British Pound (£)', value: '4', sign: '£', code: 'GBP' },
  { label: 'Japanese Yen (¥)', value: '5', sign: '¥', code: 'JPY' },
  { label: 'Australian Dollar (A$)', value: '6', sign: 'A$', code: 'AUD' },
  { label: 'Canadian Dollar (C$)', value: '7', sign: 'C$', code: 'CAD' },
  { label: 'Swiss Franc (Fr.)', value: '8', sign: 'Fr.', code: 'CHF' },
  { label: 'Chinese Yuan (¥)', value: '9', sign: '¥', code: 'CNY' },
  { label: 'Singapore Dollar (S$)', value: '10', sign: 'S$', code: 'SGD' },
  { label: 'Argentine Peso ($)', value: '11', sign: '$', code: 'ARS' },
  { label: 'Bangladeshi Taka (৳)', value: '12', sign: '৳', code: 'BDT' },
  { label: 'Brazilian Real (R$)', value: '13', sign: 'R$', code: 'BRL' },
  { label: 'Chilean Peso ($)', value: '14', sign: '$', code: 'CLP' },
  { label: 'Colombian Peso ($)', value: '15', sign: '$', code: 'COP' },
  { label: 'Czech Koruna (Kč)', value: '16', sign: 'Kč', code: 'CZK' },
  { label: 'Danish Krone (kr)', value: '17', sign: 'kr', code: 'DKK' },
  { label: 'Egyptian Pound (£)', value: '18', sign: '£', code: 'EGP' },
  { label: 'Hong Kong Dollar (HK$)', value: '19', sign: 'HK$', code: 'HKD' },
  { label: 'Hungarian Forint (Ft)', value: '20', sign: 'Ft', code: 'HUF' },
  { label: 'Indonesian Rupiah (Rp)', value: '21', sign: 'Rp', code: 'IDR' },
  { label: 'Israeli Shekel (₪)', value: '22', sign: '₪', code: 'ILS' },
  { label: 'Malaysian Ringgit (RM)', value: '23', sign: 'RM', code: 'MYR' },
  { label: 'Mexican Peso ($)', value: '24', sign: '$', code: 'MXN' },
  {
    label: 'New Zealand Dollar (NZ$)',
    value: '25',
    sign: 'NZ$',
    code: 'NZD',
  },
  { label: 'Norwegian Krone (kr)', value: '26', sign: 'kr', code: 'NOK' },
  { label: 'Pakistani Rupee (₨)', value: '27', sign: '₨', code: 'PKR' },
  { label: 'Peruvian Sol (S/.)', value: '28', sign: 'S/.', code: 'PEN' },
  { label: 'Philippine Peso (₱)', value: '29', sign: '₱', code: 'PHP' },
  { label: 'Polish Zloty (zł)', value: '30', sign: 'zł', code: 'PLN' },
  { label: 'Romanian Leu (lei)', value: '31', sign: 'lei', code: 'RON' },
  { label: 'Russian Ruble (₽)', value: '32', sign: '₽', code: 'RUB' },
  { label: 'Saudi Riyal (﷼)', value: '33', sign: '﷼', code: 'SAR' },
  { label: 'South African Rand (R)', value: '34', sign: 'R', code: 'ZAR' },
  { label: 'South Korean Won (₩)', value: '35', sign: '₩', code: 'KRW' },
  { label: 'Swedish Krona (kr)', value: '36', sign: 'kr', code: 'SEK' },
  { label: 'Thai Baht (฿)', value: '37', sign: '฿', code: 'THB' },
  { label: 'Turkish Lira (₺)', value: '38', sign: '₺', code: 'TRY' },
  { label: 'UAE Dirham (د.إ)', value: '39', sign: 'د.إ', code: 'AED' },
  { label: 'Vietnamese Dong (₫)', value: '40', sign: '₫', code: 'VND' },
];

export let demoRegular = {
  InvoiceSettings: {
    invoicesettingsid: 0,
    companyid: 744,
    enteredtimestamp: 1723460147,
    expiredtimestamp: 0,
    typecd: 'RegularSettings',
    invoiceheading: 'F Invoice',
    signaturetext: 'ananda krishnan',
    declarationatfooter:
      'We declare that this invoice shows the actual price of the goods described and that all particulars are true and correct. Thank you for your business.',
    termsandcondition:
      'All sales are final, and returns are only accepted for defective goods or services, with claims to be made within 7 days of receipt. Delivery dates ar',
    declarationatfooterflag: 1,
    termsandconditionsflag: 1,
    companyname: 1,
    companycin: 1,
    invoicenumber: 1,
    companyaddress: 1,
    companylogo: 1,
    invoicedate: 1,
    companycontactnumber: 1,
    companyemail: 1,
    paymentmode: 1,
    companygstin: 1,
    companywebsite: 1,
    creditperiod: 1,
    companypan: 1,
    companybankdetails: 1,
    paymentduedate: 1,
    customerlegalname: 1,
    customergstin: 1,
    lutbonddetails: 1,
    customerdisplayname: 1,
    placeofsupply: 1,
    dispatchdetails: 1,
    customerbillingaddress: 1,
    customercontactperson: 1,
    customercontactnumber: 0,
    customername: 0,
    ewaybilldetails: 1,
    customershippingaddress: 1,
    customerordernoanddate: 1,
    einvoicedetails: 1,
    itemwisediscount: 1,
    hsnsacode: 1,
    showroundoff: 1,
    hsnsasummarytable: 1,
    invoicedescription: 1,
    regularinvoicesignaturefilename: "thex-null-1720092402953-Jon_Kirsch's_Signature.jpg",
    lastupdatedby: null,
    statuscode: null,
    statusmessage: null,
    posinvoicesignaturefilename: null,
    defaultsetting: 0,
    bankdetails: 'Bank Name: Canara \nAccount No: 23423434\nIFSC: 2344323',
    upi_id: 'hdduu@ybl',
    __typename: 'InvoiceSettings',
  },
  bankDetails: undefined,
  billingAddressDetails: {
    billingAddress: '39, C.R. AVENUE,',
    states: 'West BengalDistrict',
    district: 'KolkataDistrict',
    country: 'IndiaState',
    pincode: '700012',
    stateCD: {
      label: 'West Bengal',
      value: 'West BengalDistrict',
    },
    countryCD: {
      label: 'India',
      value: 'IndiaState',
    },
    districtCD: {
      label: 'Kolkata',
      value: 'KolkataDistrict',
    },
    gstin: '',
    customerName: '',
    errorStatus: {
      billingAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      customerName: false,
    },
    errorFields: {
      billingAddress: '',
      states: '',
      district: '',
      country: '',
      pincode: '',
      gstin: '',
      customerName: '',
    },
  },
  companyDetails: {
    CompanyID: 744,
    EnteredTimeStamp: 1717564974,
    ExpiredTimeStamp: 0,
    CompanyName: 'test',
    StatusCode: null,
    StatusMessage: null,
    relatedCompanyDetailsNew: [
      {
        CompanyID: 744,
        EnteredTimeStamp: 1720156738,
        ExpiredTimeStamp: 0,
        WebsiteURL: '',
        CurrencyCD: 1,
        AccountInventoryFlag: 0,
        PANNumber: 'AABCF8078M',
        TDSTCSNumber: '',
        CINRegistrationNumber: '',
        RegistrationType: 2,
        GSTRPeriod: '',
        LUT: '0',
        LUTBondValidFrom: 0,
        EwayBillFlag: 0,
        GSTApplicableFrom: 0,
        ThresholdLimitCD: 0,
        ThresholdLimitAmount: 0,
        CompanyShort: 'test',
        LUTBondToDate: 0,
        InvoiceDetailApplicableFromDate: 0,
        TDSApplicable: 0,
        GSTCategory: '',
        FinancialYearStartAndEndMonth: 0,
        CompanyLogoUrl: '',
        MSMEType: '',
        UdhyamRegNo: '',
        UdhyamDocs: '',
        EwayBillStartDate: 0,
        MinAmountEwayInter: 0,
        MinAmountEwayIntra: 0,
        EInvoiceFlag: 0,
        EInvoiceStartingDate: 0,
        GSTCompensationCessFlag: 1,
        TradeLicenseNumber: '',
        TradeLicenseStartDate: 0,
        TradeLicenseEndDate: 0,
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        CINRegistrationDate: 0,
        StatusCode: null,
        StatusMessage: null,
        ActiveFlag: null,
        RelatedFinancialYearData: [
          {
            FinancialYearID: 985,
            CompanyID: 744,
            CompanyBranchID: 0,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            StartDate: 1711929600,
            EndDate: 1743379200,
            StartYear: '2024',
            EndYear: '2025',
            Comments: '',
            UserID: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            AliasName: '',
            StatusCode: null,
            StatusMessage: null,
            FreezeStatus: 0,
            TransferDate: null,
            FreezeDate: null,
            __typename: 'FinancialYear',
          },
        ],
        __typename: 'CompanyDetails',
      },
    ],
    relatedCompanyEntity: [
      {
        ID: 1901,
        CompanyID: 744,
        EnteredTimeStamp: 1718000185,
        ExpiredTimeStamp: 0,
        LegalName: 'test',
        GSTIN: '07AABCF8078M1Z3',
        FinancialYearCode: '2023',
        CompanyEntityType: '',
        StartDate: 0,
        StatusCode: null,
        StatusMessage: null,
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        __typename: 'CompanyEntity',
      },
    ],
    relatedEmailContacts: [
      {
        ID: 2817,
        ObjectType: 'COMPANY',
        ObjectID: '744',
        EnteredTimeStamp: 1717564974,
        ExpiredTimeStamp: 0,
        EmailAddress: 'granandakrish2n4an+regular@gmail.com',
        VerifiedDateTime: 10,
        PromotionsSignup: '0',
        StatusCode: null,
        StatusMessage: null,
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        __typename: 'EmailContacts',
      },
    ],
    relatedPhoneContacts: [
      {
        ID: 839,
        ObjectType: 'COMPANY',
        ObjectID: '744',
        EnteredTimeStamp: 1717564974,
        ExpiredTimeStamp: 0,
        CountryCode: '1',
        PhoneNumber: '+91 81119 66294',
        VerifiedDateTime: 0,
        PromotionsSignup: '',
        SMSAllowed: '',
        CallAllowed: '',
        WhatsappAllowed: '',
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        StatusCode: null,
        StatusMessage: null,
        __typename: 'PhoneContacts',
      },
    ],
    relatedAddressEntity: [
      {
        ID: 249739,
        ObjectType: 'COMPANY',
        ObjectID: '744',
        EnteredTimeStamp: 1720156737,
        ExpiredTimeStamp: 0,
        Line1: 'hjghg************',
        Line2: '',
        Line3: '',
        City: 'kollam',
        StateCode: 'Kerala',
        StatusCode: null,
        StatusMessage: null,
        PINCode: '691536',
        CountryCode: 'IndiaState',
        District: 'KollamDistrict',
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        __typename: 'AddressEntity',
      },
    ],
    LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
    AddressEntityID: 249739,
    ObjectType: 'COMPANY',
    Line1: 'hjghg************',
    Line2: '',
    Line3: '',
    City: 'kollam',
    StateCode: 'Kerala',
    PINCode: '691536',
    CountryCode: 'IndiaState',
    District: 'KollamDistrict',
    FinancialYearID: null,
    __typename: 'Company',
  },
  companyState: 31,
  countryName: {
    label: 'India',
    value: 'IndiaState',
  },
  data: {
    orderNumber: '',
    entryDate: '2024-08-13',
    invoiceDate: '2024-08-13',
    customerOrderDate: '2024-08-13',
    voucherNumber: 'AIR102',
    partyName: {
      label: 'AIR INDIA ',
      value: 2563,
      legalName: 'AIR INDIA LIMITED',
      consigneeGSTIN: '',
      consigneeName: '',
      accountsID: 1070,
      gstin: '19AACCN6194P1ZM',
      placeOfSupply: '19',
      PartyTypeCd: 'CUSTOMER',
      creditPeriod: '0',
      gstCategory: 'RBR',
      billingCurrency: '1',
      tdsSection: '',
      tdsPercentage: 0,
    },
    supplier: '',
    paymentType: 'Credit',
    receivedAmount: '',
    receivedAccount: {
      label: '',
      value: '',
    },
    creditPeriod: '2',
    bankReferenceNo: '',
    dueDate: '2024-08-15T18:30:00.000Z',
    tdsFlag: '',
    tdsOptions: '',
    tdsAmount: '0.00',
    adjustments: 212.4,
    currency: {
      label: 'Rupee (₹)',
      value: '1',
      sign: '₹',
      code: 'INR',
    },
    currencyRate: '1.00',
    ineligibleITCFlag: '',
    reverseChargeFlag: 0,
    remarks: '',
    placeOfSupply: {
      label: 'WEST BENGAL',
      value: 19,
    },
    address: '',
    billingAddress: '39, C.R. AVENUE,',
    deliveryAddress: '39, C.R. AVENUE,',
    gstin: '19AACCN6194P1ZM',
    transportMode: '',
    vehicleNumber: '',
    dateOfDispatch: '2024-08-13',
    gstCategory: '',
    ewayBillNo: '',
    transactionVoucher: 'RECT15',
    CancelFlag: 0,
    tcsFlag: 0,
    tcsOptions: 26,
    tdsPercent: 0,
    tcsPercent: '1',
    tcsAmount: '21.24',
    manualTCSAmt: 0,
    manualTDSAmt: 0,
    seriesVouchers: {
      label: '',
      value: '',
    },
    transactionSeries: {
      label: 'RECT',
      value: 'RECT',
    },
    consigneeName: 'AIR INDIA LIMITED',
    consigneeGST: '19AACCN6194P1ZM',
    roundOff: '100',
    adjustmentsType: '1',
    adjustmentsValue: '10',
    balanceDueAmt: 2655.56,
    partyCategory: 'RBR',
    errorStatus: {
      orderNumber: false,
      entryDate: false,
      invoiceDate: false,
      customerOrderDate: false,
      voucherNumber: false,
      partyName: false,
      paymentType: false,
      receivedAmount: false,
      receivedAccount: false,
      creditPeriod: false,
      bankReferenceNo: false,
      dueDate: false,
      tdsFlag: false,
      tdsOptions: false,
      tdsAmount: false,
      tcsFlag: false,
      tcsOptions: false,
      tcsAmount: false,
      adjustments: false,
      ineligibleITCFlag: false,
      reverseChargeFlag: false,
      remarks: false,
      placeOfSupply: false,
      address: false,
      currency: false,
      gstin: false,
      currencyRate: false,
      transportMode: false,
      vehicleNumber: false,
      dateOfDispatch: false,
      ewayBillNo: false,
      transactionVoucher: false,
      seriesVouchers: false,
      transactionSeries: false,
      consigneeName: false,
      consigneeGST: false,
      roundOff: false,
      tdsPercent: false,
      tcsPercent: false,
      adjustmentsType: false,
      adjustmentsValue: false,
      balanceDueAmt: false,
    },
    errorFields: {
      orderNumber: '',
      entryDate: '',
      invoiceDate: '',
      customerOrderDate: '',
      voucherNumber: '',
      partyName: '',
      paymentType: '',
      receivedAmount: '',
      receivedAccount: '',
      creditPeriod: '',
      bankReferenceNo: '',
      dueDate: '',
      tcsFlag: '',
      tcsOptions: '',
      tcsAmount: '',
      tdsFlag: '',
      tdsOptions: '',
      currency: '',
      tdsAmount: '',
      adjustments: '',
      ineligibleITCFlag: '',
      currencyRate: '',
      reverseChargeFlag: '',
      remarks: '',
      placeOfSupply: '',
      address: '',
      gstin: '',
      transportMode: '',
      vehicleNumber: '',
      dateOfDispatch: '',
      ewayBillNo: '',
      transactionVoucher: '',
      seriesVouchers: '',
      transactionSeries: '',
      consigneeName: '',
      consigneeGST: '',
      tdsPercent: '',
      tcsPercent: '',
      roundOff: '',
      adjustmentsType: '',
      adjustmentsValue: '',
      balanceDueAmt: '',
    },
  },
  deliveryAddressDetails: {
    deliveryAddress: '39, C.R. AVENUE,',
    states: 'West BengalDistrict',
    district: 'KolkataDistrict',
    country: 'IndiaState',
    pincode: '700012',
    stateCD: {
      label: 'West Bengal',
      value: 'West BengalDistrict',
    },
    countryCD: {
      label: 'India',
      value: 'IndiaState',
    },
    districtCD: {
      label: 'Kolkata',
      value: 'KolkataDistrict',
    },
    gstin: '',
    customerName: '',
    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      gstin: false,
      customerName: false,
    },
    errorFields: {
      deliveryAddress: '',
      states: '',
      district: '',
      country: '',
      pincode: '',
      gstin: '',
      customerName: '',
    },
  },
  itemEntry: undefined,
  items: [
    {
      itemCode: {
        label: 'G351',
        value: 3012,
      },
      name: {
        label: 'Product',
        value: 3012,
      },
      priceType: {
        label: 'Wholesale',
        value: 'Wholesale',
      },
      ledgerAccount: {
        label: 'Sales A/c',
        value: 17,
      },
      HSN: {
        label: '854460 - Other electric conductors, for a voltage exceeding 1000 V',
        value: '854460',
        companyID: 0,
        hsnID: 19711,
        codeType: 'HSN',
        description: 'Other electric conductors, for a voltage exceeding 1000 V',
      },
      qty: '02',
      units: '1004642140',
      rate: 1000,
      amount: 2000,
      dicount: 200,
      taxableAMount: 1800,
      GSTRate: 18,
      taxability: {
        label: 'Taxable',
        value: 1,
      },
      IGST: 342,
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: 180,
      netAmount: 2232,
      editable: false,
      new: false,
      type: 'item',
    },
    {
      itemCode: {
        label: 'G352',
        value: 3015,
      },
      name: {
        label: 'Product 1',
        value: 3015,
      },
      priceType: {
        label: 'Wholesale',
        value: 'Wholesale',
      },
      ledgerAccount: {
        label: 'Sales A/c',
        value: 17,
      },
      HSN: {
        label: '1001 - WHEAT AND MESLIN - Durum wheat :',
        value: '1001',
        companyID: 0,
        hsnID: 2353,
        codeType: 'HSN',
        description: 'WHEAT AND MESLIN - Durum wheat :',
      },
      qty: '03',
      units: '1004642140',
      reason: '',
      rate: 120,
      amount: 360,
      dicount: 36,
      taxableAMount: 324,
      GSTRate: 28,
      taxability: {
        label: 'Taxable',
        value: 1,
      },
      IGST: 90.72,
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: '100',
      netAmount: 514.72,
      editable: false,
      new: false,
      type: 'item',
    },
    {
      itemCode: {
        label: '',
        value: '',
      },
      name: {
        label: '',
        value: '',
      },
      priceType: {
        label: '',
        value: '',
      },
      ledgerAccount: {
        label: '',
        value: '',
      },
      HSN: {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      },
      qty: '',
      units: '',
      reason: '',
      rate: 0,
      amount: 0,
      dicount: 0,
      taxableAMount: 0,
      GSTRate: '',
      taxability: {
        label: '',
        value: '',
      },
      IGST: '0.00',
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: 0,
      netAmount: 0,
      editable: true,
      new: true,
      type: 'item',
    },
  ],
  nonItems: [
    {
      ledgerAccount: {
        label: '',
        value: '',
      },
      HSN: {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      },
      description: '',
      taxableAMount: 0,
      GSTRate: '',
      taxability: {
        label: '',
        value: '',
      },
      IGST: 0,
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: 0,
      netAmount: 0,
      editable: true,
      new: true,
      type: 'nonitem',
    },
  ],
  nonItemwiseTableAmount: 2746.7200000000003,
  partyDetails: {
    ID: 251822,
    ObjectType: 'PartyBilling',
    ObjectID: '2563',
    EnteredTimeStamp: 1723542137,
    ExpiredTimeStamp: 0,
    Line1: '39, C.R. AVENUE,',
    Line2: '',
    Line3: '',
    City: 'KOLKATA',
    StateCode: 'West BengalDistrict',
    StatusCode: null,
    StatusMessage: null,
    PINCode: '700012',
    CountryCode: 'IndiaState',
    District: 'KolkataDistrict',
    LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
    __typename: 'AddressEntity',
  },
  registrationType: 2,
  stateName: {
    label: 'West Bengal',
    value: 'West BengalDistrict',
  },
  stateOfSupply: {
    label: 'Kolkata',
    value: 'KolkataDistrict',
  },
  tabelTotAmount: 2360,
  totAmount: 2360,
  totDiscount: 2360,
  totGST: 432.72,
  totGstCess: 280,
  totNetAmount: 2655.56,
  totTaxableAmount: 2124,
  units: [
    {
      option: 'Bags',
      value: '1004642132',
      UQC: 'BAG',
    },
    {
      option: 'Bale',
      value: '1004642133',
      UQC: 'BAL',
    },
    {
      option: 'Billions Of Units',
      value: '1004642136',
      UQC: 'BOU',
    },
    {
      option: 'Bottles',
      value: '1004642138',
      UQC: 'BTL',
    },
    {
      option: 'Box',
      value: '1004642137',
      UQC: 'BOX',
    },
    {
      option: 'Buckles',
      value: '1004642135',
      UQC: 'BKL',
    },
    {
      option: 'Bunches',
      value: '1004642139',
      UQC: 'BUN',
    },
    {
      option: 'Bundles',
      value: '1004642134',
      UQC: 'BDL',
    },
    {
      option: 'Cans',
      value: '1004642140',
      UQC: 'CAN',
    },
    {
      option: 'Cartons',
      value: '1004642144',
      UQC: 'CTN',
    },
    {
      option: 'Centimeter',
      value: '1004642143',
      UQC: 'CMS',
    },
    {
      option: 'Cubic Centimeter',
      value: '1004642142',
      UQC: 'CCM',
    },
    {
      option: 'Cubic Meter',
      value: '1004642141',
      UQC: 'CBM',
    },
    {
      option: 'Dozen',
      value: '1004642145',
      UQC: 'DOZ',
    },
    {
      option: 'Drum',
      value: '1004642146',
      UQC: 'DRM',
    },
    {
      option: 'Grams',
      value: '1004642148',
      UQC: 'GMS',
    },
    {
      option: 'Great Gross',
      value: '1004642147',
      UQC: 'GGR',
    },
    {
      option: 'Gross',
      value: '1004642149',
      UQC: 'GRS',
    },
    {
      option: 'Gross Yards',
      value: '1004642150',
      UQC: 'GYD',
    },
    {
      option: 'Kilograms',
      value: '1004642151',
      UQC: 'KGS',
    },
    {
      option: 'Kiloliter',
      value: '1004642152',
      UQC: 'KLR',
    },
    {
      option: 'Kilometre',
      value: '1004642153',
      UQC: 'KME',
    },
    {
      option: 'Meters',
      value: '1004642155',
      UQC: 'MTR',
    },
    {
      option: 'Metric Tons',
      value: '1004642156',
      UQC: 'MTS',
    },
    {
      option: 'Millilitre',
      value: '1004642154',
      UQC: 'MLT',
    },
    {
      option: 'Not Applicable',
      value: '1004642229',
      UQC: null,
    },
    {
      option: 'Numbers(No)',
      value: '1004642157',
      UQC: 'NOS',
    },
    {
      option: 'Others',
      value: '1004642175',
      UQC: 'OTH',
    },
    {
      option: 'Packs',
      value: '1004642158',
      UQC: 'PAC',
    },
    {
      option: 'Pairs',
      value: '1004642160',
      UQC: 'PRS',
    },
    {
      option: 'Pieces',
      value: '1004642159',
      UQC: 'PCS',
    },
    {
      option: 'Quintal',
      value: '1004642161',
      UQC: 'QTL',
    },
    {
      option: 'Rolls',
      value: '1004642162',
      UQC: 'ROL',
    },
    {
      option: 'Sets',
      value: '1004642163',
      UQC: 'SET',
    },
    {
      option: 'Square Feet',
      value: '1004642164',
      UQC: 'SQF',
    },
    {
      option: 'Square Meters',
      value: '1004642165',
      UQC: 'SQM',
    },
    {
      option: 'Square Yards',
      value: '1004642166',
      UQC: 'SQY',
    },
    {
      option: 'Tablets',
      value: '1004642167',
      UQC: 'TBS',
    },
    {
      option: 'Ten Gross',
      value: '1004642168',
      UQC: 'TGM',
    },
    {
      option: 'Thousands',
      value: '1004642169',
      UQC: 'THD',
    },
    {
      option: 'Tonnes',
      value: '1004642170',
      UQC: 'TON',
    },
    {
      option: 'Tubes',
      value: '1004642171',
      UQC: 'TUB',
    },
    {
      option: 'Units',
      value: '1004642173',
      UQC: 'UNT',
    },
    {
      option: 'Us Gallons',
      value: '1004642172',
      UQC: 'UGS',
    },
    {
      option: 'Yards',
      value: '1004642174',
      UQC: 'YDS',
    },
  ],
  eInvoiceDetails: {
    irn: '6b20c297c1f41344feae0391a74d7bb82e1f831d822ace8fed08de8af6f33f9d',
    ack_no: ' 152522429951007',
    ack_dt: '22-07-2025',
    ein_upi: 'gfg@hdfcbank',
  },
  dateOfDispatch:'13-Aug-2024',
  transportMode:'road',
  vehicleNumber:'KL07XXXX'
};

export const demoPos = {
  InvoiceSettings: {
    InvoiceSettingsID: 0,
    CompanyID: 744,
    EnteredTimeStamp: 1723460148,
    ExpiredTimeStamp: 0,
    TypeCD: 'PosSettings',
    InvoiceHeading: 'Pos',
    SignatureText: 'ananda krishnan gr',
    DeclarationAtFooter: null,
    TermsAndCondition: null,
    DeclarationAtFooterFlag: null,
    TermsAndConditionsFlag: null,
    CompanyName: 1,
    CompanyCIN: 1,
    InvoiceNumber: 1,
    CompanyAddress: 1,
    CompanyLogo: 1,
    InvoiceDate: 1,
    CompanyContactNumber: 1,
    CompanyEmail: 1,
    PaymentMode: 1,
    CompanyGSTIN: 1,
    CompanyWebsite: 1,
    CreditPeriod: null,
    CompanyPAN: 1,
    CompanyBankDetails: null,
    PaymentDueDate: null,
    CustomerLegalName: null,
    CustomerGSTIN: null,
    LUTBondDetails: null,
    CustomerDisplayName: null,
    PlaceOfSupply: null,
    DispatchDetails: null,
    CustomerBillingAddress: null,
    CustomerContactPerson: null,
    CustomerContactNumber: 1,
    CustomerName: 1,
    EWayBillDetails: null,
    CustomerShippingAddress: null,
    CustomerOrderNoAndDate: null,
    EInvoiceDetails: null,
    ItemWiseDiscount: 1,
    HSNSACode: 1,
    ShowRoundOff: 1,
    HSNSASummaryTable: null,
    InvoiceDescription: null,
    RegularInvoiceSignatureFileName: '',
    LastUpdatedBy: null,
    StatusCode: null,
    StatusMessage: null,
    PosInvoiceSignatureFileName: null,
    DefaultSetting: 0,
    BankDetails: 'bank details',
    UPI_ID: 'hdduu@ybl',
    __typename: 'InvoiceSettings',
  },
  companyDetails: {
    CompanyID: 744,
    EnteredTimeStamp: 1717564974,
    ExpiredTimeStamp: 0,
    CompanyName: 'test',
    StatusCode: null,
    StatusMessage: null,
    relatedCompanyDetailsNew: [
      {
        CompanyID: 744,
        EnteredTimeStamp: 1720156738,
        ExpiredTimeStamp: 0,
        WebsiteURL: '',
        CurrencyCD: 1,
        AccountInventoryFlag: 0,
        PANNumber: 'AABCF8078M',
        TDSTCSNumber: '',
        CINRegistrationNumber: '',
        RegistrationType: 2,
        GSTRPeriod: '',
        LUT: '0',
        LUTBondValidFrom: 0,
        EwayBillFlag: 0,
        GSTApplicableFrom: 0,
        ThresholdLimitCD: 0,
        ThresholdLimitAmount: 0,
        CompanyShort: 'test',
        LUTBondToDate: 0,
        InvoiceDetailApplicableFromDate: 0,
        TDSApplicable: 0,
        GSTCategory: '',
        FinancialYearStartAndEndMonth: 0,
        CompanyLogoUrl: '',
        MSMEType: '',
        UdhyamRegNo: '',
        UdhyamDocs: '',
        EwayBillStartDate: 0,
        MinAmountEwayInter: 0,
        MinAmountEwayIntra: 0,
        EInvoiceFlag: 0,
        EInvoiceStartingDate: 0,
        GSTCompensationCessFlag: 1,
        TradeLicenseNumber: '',
        TradeLicenseStartDate: 0,
        TradeLicenseEndDate: 0,
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        CINRegistrationDate: 0,
        StatusCode: null,
        StatusMessage: null,
        BusinessType: [
          {
            BusinessTypeID: 3705,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            BusinessType: 'Retailer',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'BusinessType',
          },
          {
            BusinessTypeID: 3706,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            BusinessType: 'Wholesaler',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'BusinessType',
          },
          {
            BusinessTypeID: 3707,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            BusinessType: 'Distributor',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'BusinessType',
          },
          {
            BusinessTypeID: 3708,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            BusinessType: 'Manufacturer',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'BusinessType',
          },
          {
            BusinessTypeID: 3709,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            BusinessType: 'Service Provider',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'BusinessType',
          },
        ],
        IndustryType: [
          {
            IndustryTypeID: 33912,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Advertising',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33913,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Agriculture',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33914,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Animal Husbandry',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33915,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Aviation',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33916,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Biotechnology',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33917,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Business Process Management',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33918,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Clothing Industry',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33919,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Commerce',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33920,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Conglomerate',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33921,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Construction Engineering',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33922,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Distribution',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33923,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'E-commerce',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33924,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Economics',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33925,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Education',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33926,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Energy Industry',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33927,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Engineering',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33928,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Entertainment',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33929,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Fast-Moving Consumer Goods',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33930,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Finance',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33931,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Financial Services',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33932,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Fintech',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33933,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Film Industry',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33934,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Health Care',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33935,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Hospitality',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33936,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Hospitality Industry',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33937,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Insurance',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33938,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Investment',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33939,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Management',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33940,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Marketing',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33941,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Mechanical Engineering',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33942,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Media',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33943,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Medical Device',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33944,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Metallurgy',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33945,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Mining',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33946,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Others',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33947,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Pharmaceutics',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33948,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Rail Transport',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33949,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Real Estate',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33950,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Renewable Energy',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33951,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Research',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33952,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Research and Development',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33953,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Retail',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33954,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Robotics',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33955,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Software',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33956,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Steel',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33957,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Technology',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33958,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Telecommunications',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
          {
            IndustryTypeID: 33959,
            CompanyID: 744,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            IndustryType: 'Trade',
            LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            Restrictedflag: 1,
            IsActive: 0,
            __typename: 'IndustryType',
          },
        ],
        ActiveFlag: null,
        RelatedFinancialYearData: [
          {
            FinancialYearID: 985,
            CompanyID: 744,
            CompanyBranchID: 0,
            EnteredTimeStamp: 1717564974,
            ExpiredTimeStamp: 0,
            StartDate: 1711929600,
            EndDate: 1743379200,
            StartYear: '2024',
            EndYear: '2025',
            Comments: '',
            UserID: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
            AliasName: '',
            StatusCode: null,
            StatusMessage: null,
            FreezeStatus: 0,
            TransferDate: null,
            FreezeDate: null,
            __typename: 'FinancialYear',
          },
        ],
        __typename: 'CompanyDetails',
      },
    ],
    relatedCompanyEntity: [
      {
        ID: 1901,
        CompanyID: 744,
        EnteredTimeStamp: 1718000185,
        ExpiredTimeStamp: 0,
        LegalName: 'test',
        GSTIN: '07AABCF8078M1Z3',
        FinancialYearCode: '2023',
        CompanyEntityType: '',
        StartDate: 0,
        StatusCode: null,
        StatusMessage: null,
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        __typename: 'CompanyEntity',
      },
    ],
    relatedEmailContacts: [
      {
        ID: 2817,
        ObjectType: 'COMPANY',
        ObjectID: '744',
        EnteredTimeStamp: 1717564974,
        ExpiredTimeStamp: 0,
        EmailAddress: 'granandakrish2n4an+regular@gmail.com',
        VerifiedDateTime: 10,
        PromotionsSignup: '0',
        StatusCode: null,
        StatusMessage: null,
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        __typename: 'EmailContacts',
      },
    ],
    relatedPhoneContacts: [
      {
        ID: 839,
        ObjectType: 'COMPANY',
        ObjectID: '744',
        EnteredTimeStamp: 1717564974,
        ExpiredTimeStamp: 0,
        CountryCode: '1',
        PhoneNumber: '+91 81119 66294',
        VerifiedDateTime: 0,
        PromotionsSignup: '',
        SMSAllowed: '',
        CallAllowed: '',
        WhatsappAllowed: '',
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        StatusCode: null,
        StatusMessage: null,
        __typename: 'PhoneContacts',
      },
    ],
    relatedAddressEntity: [
      {
        ID: 251836,
        ObjectType: 'COMPANY',
        ObjectID: '744',
        EnteredTimeStamp: 1723545661,
        ExpiredTimeStamp: 0,
        Line1: 'hjghg',
        Line2: '',
        Line3: '',
        City: '',
        StateCode: 'Kerala',
        StatusCode: null,
        StatusMessage: null,
        PINCode: '691536',
        CountryCode: 'IndiaState',
        District: 'KollamDistrict',
        LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
        __typename: 'AddressEntity',
      },
    ],
    LastUpdatedBy: 'c0c31ea9-fa7a-4403-8453-b8f44d65e7a6',
    AddressEntityID: 251836,
    ObjectType: 'COMPANY',
    Line1: 'hjghg',
    Line2: '',
    Line3: '',
    City: '',
    StateCode: 'Kerala',
    PINCode: '691536',
    CountryCode: 'IndiaState',
    District: 'KollamDistrict',
    FinancialYearID: null,
    __typename: 'Company',
  },
  companyState: '',
  data: {
    orderNumber: '',
    entryDate: '2024-08-13',
    invoiceDate: '2024-08-13',
    customerOrderDate: '2024-08-13',
    voucherNumber: 'PINV2',
    partyName: 'Party Name',
    supplier: '',
    paymentType: 'Cash',
    receivedAmount: 106589.44,
    receivedAccount: {
      label: 'Cash A/c',
      value: 3,
    },
    creditPeriod: '',
    bankReferenceNo: '',
    dueDate: '2024-08-13',
    tdsFlag: '',
    tdsOptions: '',
    tdsAmount: '0.00',
    adjustments: 4554,
    currency: {
      label: 'Rupee (₹)',
      value: '1',
      sign: '₹',
      code: 'INR',
    },
    currencyRate: 1,
    ineligibleITCFlag: '',
    reverseChargeFlag: 0,
    remarks: '',
    placeOfSupply: {
      label: '',
      value: '',
    },
    address: '',
    billingAddress: '',
    deliveryAddress: '',
    gstin: '',
    transportMode: '',
    vehicleNumber: '',
    dateOfDispatch: '2024-08-13',
    gstCategory: '',
    ewayBillNo: '',
    transactionVoucher: 'RECT15',
    CancelFlag: 0,
    tcsFlag: 0,
    tcsOptions: 21,
    tdsPercent: '',
    tcsPercent: '1',
    tcsAmount: '910.80',
    manualTCSAmt: 0,
    manualTDSAmt: 0,
    seriesVouchers: {
      label: 'PINV',
      value: 'PINV',
    },
    transactionSeries: {
      label: 'RECT',
      value: 'RECT',
    },
    consigneeName: '',
    consigneeGST: '',
    roundOff: '100',
    adjustmentsType: '1',
    adjustmentsValue: '05',
    balanceDueAmt: 0,
    partyCategory: '',
    partyContactNumber: '8111XXXX94',
    errorStatus: {
      orderNumber: false,
      entryDate: false,
      invoiceDate: false,
      customerOrderDate: false,
      voucherNumber: false,
      partyName: false,
      paymentType: false,
      receivedAmount: false,
      receivedAccount: false,
      creditPeriod: false,
      bankReferenceNo: false,
      dueDate: false,
      tdsFlag: false,
      tdsOptions: false,
      tdsAmount: false,
      tcsFlag: false,
      tcsOptions: false,
      tcsAmount: false,
      adjustments: false,
      ineligibleITCFlag: false,
      reverseChargeFlag: false,
      remarks: false,
      placeOfSupply: false,
      address: false,
      currency: false,
      gstin: false,
      currencyRate: false,
      transportMode: false,
      vehicleNumber: false,
      dateOfDispatch: false,
      ewayBillNo: false,
      transactionVoucher: false,
      seriesVouchers: false,
      transactionSeries: false,
      consigneeName: false,
      consigneeGST: false,
      roundOff: false,
      tdsPercent: false,
      tcsPercent: false,
      adjustmentsType: false,
      adjustmentsValue: false,
      balanceDueAmt: false,
      partyContactNumber: false,
    },
    errorFields: {
      orderNumber: '',
      entryDate: '',
      invoiceDate: '',
      customerOrderDate: '',
      voucherNumber: '',
      partyName: '',
      paymentType: '',
      receivedAmount: '',
      receivedAccount: '',
      creditPeriod: '',
      bankReferenceNo: '',
      dueDate: '',
      tcsFlag: '',
      tcsOptions: '',
      tcsAmount: '',
      tdsFlag: '',
      tdsOptions: '',
      currency: '',
      tdsAmount: '',
      adjustments: '',
      ineligibleITCFlag: '',
      currencyRate: '',
      reverseChargeFlag: '',
      remarks: '',
      placeOfSupply: '',
      address: '',
      gstin: '',
      transportMode: '',
      vehicleNumber: '',
      dateOfDispatch: '',
      ewayBillNo: '',
      transactionVoucher: '',
      seriesVouchers: '',
      transactionSeries: '',
      consigneeName: '',
      consigneeGST: '',
      tdsPercent: '',
      tcsPercent: '',
      roundOff: '',
      adjustmentsType: '',
      adjustmentsValue: '',
      balanceDueAmt: '',
      partyContactNumber: '',
    },
  },
  items: [
    {
      itemCode: {
        label: 'G351',
        value: 3012,
      },
      name: {
        label: 'Product 1',
        value: 3012,
      },
      priceType: {
        label: 'Wholesale',
        value: 'Wholesale',
      },
      ledgerAccount: {
        label: 'Sales A/c',
        value: 17,
      },
      HSN: {
        label: '854460 - Other electric conductors, for a voltage exceeding 1000 V',
        value: '854460',
        companyID: 0,
        hsnID: 19711,
        codeType: 'HSN',
        description: 'Other electric conductors, for a voltage exceeding 1000 V',
      },
      qty: '100',
      units: '1004642140',
      rate: 1000,
      amount: 100000,
      dicount: 10000,
      taxableAMount: 90000,
      GSTRate: 18,
      taxability: {
        label: 'Taxable',
        value: 1,
      },
      IGST: 17820,
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: 9000,
      netAmount: 108720,
      editable: false,
      new: false,
    },
    {
      itemCode: {
        label: 'G352',
        value: 3015,
      },
      name: {
        label: 'Product 2',
        value: 3015,
      },
      priceType: {
        label: 'Wholesale',
        value: 'Wholesale',
      },
      ledgerAccount: {
        label: 'Sales A/c',
        value: 17,
      },
      HSN: {
        label: '1001 - WHEAT AND MESLIN - Durum wheat :',
        value: '1001',
        companyID: 0,
        hsnID: 2353,
        codeType: 'HSN',
        description: 'WHEAT AND MESLIN - Durum wheat :',
      },
      qty: '10',
      units: '1004642140',
      reason: '',
      rate: 120,
      amount: 1200,
      dicount: 120,
      taxableAMount: 1080,
      GSTRate: 28,
      taxability: {
        label: 'Taxable',
        value: 1,
      },
      IGST: 332.64,
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: 0,
      netAmount: 1412.6399999999999,
      editable: false,
      new: false,
    },
    {
      itemCode: {
        label: '',
        value: '',
      },
      name: {
        label: '',
        value: '',
      },
      priceType: {
        label: '',
        value: '',
      },
      ledgerAccount: {
        label: '',
        value: '',
      },
      HSN: {
        label: '',
        value: '',
        companyID: '',
        hsnID: '',
        codeType: '',
        description: '',
      },
      qty: '',
      units: '',
      reason: '',
      rate: 0,
      amount: 0,
      dicount: 0,
      taxableAMount: 0,
      GSTRate: '',
      taxability: {
        label: '',
        value: '',
      },
      IGST: '0.00',
      CGST: '0.00',
      SGST: '0.00',
      GSTCess: 0,
      netAmount: 0,
      editable: true,
      new: true,
    },
  ],
  registrationType: 2,
  totAmount: 101200,
  totDiscount: 10120,
  totGST: 18152.64,
  totGstCess: 9000,
  totNetAmount: 106589.44,
};

export const AvkDAta = {
  IRN: '6b20c297c1f41344feae0391a74d7bb82e1f831d822ace8fed08de8af6f33f9d',
  Ack_no: ' 152522429951007',
  Ack_Dt: '22-07-2025',
  qr_code: 'gfg@hdfcbank',
};



export const uploadInfo = `• Supported formats: PDF, JPG, JPEG, PNG, DOC, DOCX, XLS, XLSX
• Maximum file size: 5 MB per file
• Maximum attachments: 6`;